import React from "react";
import PropTypes from "prop-types";

import "./style.scss";

export function StepNode(props) {
  const mobView = window.matchMedia("(max-width: 700px)");

  mobView.addEventListener("change", function () {
    onIncorrectSubStep(mobView);
  });

  const getIsCorrect = (c) => c.answerId.includes(c.droppedId);

  const setFeedback = (c, isCorrect) => {
    if (isCorrect) return "";
    else return c.feedbackMessage;
  };

  const getIsEmpty = (c) => c.droppedId === null;

  const onDropStep = (positionId) =>
    React.useCallback((params) => {
      props.onDropStep({ ...params, positionId, nodeId: props.nodeId });
    }, []);

  const onRemoveStep = (positionId) =>
    React.useCallback(() => {
      props.onRemoveStep({ positionId, nodeId: props.nodeId });
    }, []);

  const onIncorrectSubStep = (query) => {
    if (query.matches) return true;
    else return false;
  };

  const experimentStep = (nodeComponent) => {
    const isCorrect = getIsCorrect(nodeComponent);
    return React.createElement(props.experimentStepNode, {
      ...props.experimentStepNode.props,
      isCorrect,
      key: nodeComponent.id,
      onDrop: onDropStep(nodeComponent.id),
      text: nodeComponent.text,
      tabIndex: props.tabIndex,
      color: nodeComponent?.color,
      isEmpty: getIsEmpty(nodeComponent),
      droppedId: nodeComponent.droppedId,
      placeHolder: nodeComponent.placeHolder,
      onRemove: onRemoveStep(nodeComponent.id),
      feedbackMessage: setFeedback(nodeComponent, isCorrect),
      showTooltip: onIncorrectSubStep(mobView),
    });
  };

  return (
    <div className="design-view__stepNode">
      {props.nodeComponents.map(experimentStep)}
    </div>
  );
}

StepNode.propTypes = {
  /**
   * nodeId
   */
  nodeId: PropTypes.number,
  /**
   * tabIndex to set on element and its children
   */
  tabIndex: PropTypes.number,
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * List of Components too display in Node
   */
  nodeComponents: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Main title for the step/option
       */
      text: PropTypes.string,
      /**
       * placeHolder to display when step is emtpy
       */
      placeHolder: PropTypes.string,
      /**
       * Theme color of the option
       */
      color: PropTypes.string,
      /**
       * feedback message for the step
       */
      feedbackMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
      ]),
      /**
       * List of Node/Component Ids' that are correct for the spot
       */
      answerId: PropTypes.arrayOf(PropTypes.number),
      /**
       * Id of the component currently dropped in the spot
       */
      droppedId: PropTypes.oneOfType([
        PropTypes.oneOf([null]),
        PropTypes.number,
      ]),
    })
  ),
  /**
   * React Component to be used as ExperimentStep Component
   */
  experimentStepNode: PropTypes.elementType,
  /**
   * Function for when an Option in dropped in Node
   */
  onDropStep: PropTypes.func,
  /**
   * Function for when a Step is removed from Node
   */
  onRemoveStep: PropTypes.func,
};

StepNode.defaultProps = {
  className: "",
};
